import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowDownRight } from "lucide-react";
import { HERO } from "../data";

export const Hero = () => {
  const navigate = useNavigate();
  const goPage = (to) => { navigate(to); window.scrollTo({ top: 0, behavior: "smooth" }); };
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const t = setInterval(() => {
      setCurrent((c) => (c + 1) % HERO.images.length);
    }, 5000);
    return () => clearInterval(t);
  }, []);

  return (
    <section data-testid="hero-section" className="bg-white">
      {/* Slider — foto a piena larghezza, proporzioni originali, con scritte sopra */}
      <div className="relative w-full bg-white pt-20 md:pt-24">
        <img
          key={current}
          src={HERO.images[current]}
          alt="Vetrata panoramica VEPA installata da VETRO DESIGN ITALIA"
          data-testid={`hero-slide-${current}`}
          loading="eager"
          className="block w-full h-auto"
        />

        {/* Velatura per leggibilità del testo */}
        <div className="absolute inset-0 bg-gradient-to-t from-white/90 via-white/10 to-white/30 pointer-events-none" />

        {/* Scritte sopra la foto */}
        <div className="absolute inset-0 flex items-end">
          <div className="max-w-[1400px] mx-auto w-full px-6 md:px-12 pb-16 md:pb-20">
            <div className="max-w-3xl mx-auto text-center">
              <div className="text-center mb-8">
                <p className="text-lg md:text-2xl uppercase tracking-[0.3em] text-foreground/85 font-medium">
                  Vetrate Panoramiche
                </p>
                <p className="text-lg md:text-2xl uppercase tracking-[0.3em] text-foreground/85 font-medium mt-3">
                  Soluzioni Vetro per ambienti Indoor &amp; Outdoor
                </p>
              </div>
              <h1 className="font-serif font-light text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-[0.95]">
                {HERO.headline}
              </h1>
              <p className="mt-6 text-base md:text-lg text-foreground/80 max-w-xl mx-auto font-light leading-relaxed">
                {HERO.subheadline}
              </p>
              <div className="mt-8 flex flex-col sm:flex-row gap-4 justify-center">
                <button
                  data-testid="hero-cta-projects"
                  onClick={() => goPage("/realizzazioni-vetrate-panoramiche")}
                  className="group inline-flex items-center gap-3 bg-black text-white px-8 py-4 text-sm uppercase tracking-wide hover:gap-5 transition-all duration-300"
                >
                  Scopri i Progetti
                  <ArrowDownRight strokeWidth={1.2} className="w-4 h-4 group-hover:rotate-45 transition-transform duration-300" />
                </button>
                <button
                  data-testid="hero-cta-contact"
                  onClick={() => goPage("/contatti-vetrate-panoramiche")}
                  className="inline-flex items-center gap-3 border border-black/30 px-8 py-4 text-sm uppercase tracking-wide hover:bg-black hover:text-white transition-colors duration-300"
                >
                  Richiedi Preventivo
                </button>
              </div>
              <div className="mt-4 flex justify-center">
                <button
                  data-testid="hero-cta-configuratore"
                  onClick={() => goPage("/configuratore")}
                  className="group inline-flex items-center gap-3 bg-teal-600 text-white px-8 py-4 text-sm uppercase tracking-wide shadow-[0_8px_30px_rgba(13,148,136,0.35)] hover:bg-teal-700 hover:gap-5 transition-all duration-300"
                >
                  Configuratore Tecnico-Commerciale
                  <ArrowDownRight strokeWidth={1.2} className="w-4 h-4 group-hover:rotate-45 transition-transform duration-300" />
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Pallini navigazione */}
        <div className="absolute bottom-4 left-0 right-0 flex gap-3 justify-center z-10">
          {HERO.images.map((_, i) => (
            <button
              key={i}
              data-testid={`hero-dot-${i}`}
              onClick={() => setCurrent(i)}
              aria-label={`Slide ${i + 1}`}
              className={`h-1 transition-all duration-500 ${i === current ? "w-10 bg-black" : "w-5 bg-black/30 hover:bg-black/60"}`}
            />
          ))}
        </div>
      </div>
    </section>
  );
};
